import BrazeBanner from '~/components/BrazeBanner';
import DownloadAppBlock from '~/components/DownloadAppBlock';
import PageLoadErrorBoundary from '~/components/PageLoadErrorBoundary';

import PlpView, * as plp from '../PlpView';
import SoleMarketFaq from './SoleMarketFaq';
import SoleMarketInfo from './SoleMarketInfo';
import SoleMarketSignUpBanner from './SoleMarketSignUpBanner';

export default function MarketplaceHub() {
  return (
    <>
      <SoleMarketSignUpBanner />
      <BrazeBanner placementId="plp-top" />
      <PlpView
        allowNotifications={false}
        showAppBanner={false}
        showPromotion={false}
      />
      <SoleMarketInfo />
      <SoleMarketFaq />
      <DownloadAppBlock
        downloadLink="https://thesolesupplier.onelink.me/BPkz/m35evxoc"
        qrCode="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/download_app_homepage_qr_code.png"
        pagePosition="Body"
      />
    </>
  );
}

export function ErrorBoundary() {
  return <PageLoadErrorBoundary pageType="plp" />;
}

export const shouldRevalidate = plp.shouldRevalidate;
export { loader } from '../loader.server';
